const BASE_URL = 'https://evotingreact.betechdeveloper.com/admin/public';
const URL_API =  BASE_URL +  '/api/';

export {
    BASE_URL,
    URL_API
}
